module.exports = __webpack_public_path__ + "media/img/covers/header-cover-6b3d49ac8e81a78dbc299b35f52dcc9b.jpg";